import { isJson } from "../../../../common/helpers/json";
import { hours_list } from "../../../../common/constants/hours_list";
import { minutes_list } from "../../../../common/constants/minutes_list";
import { toHoursAndMinutes } from "../../../../common/helpers/time";

class AdminSettingsPoliciesDrivesController {
  constructor(PoliciesModel, PoliciesStoreService, FlashService, UserService) {
    this.hoursList = hours_list;
    this.minutesList = minutes_list;
    this.busy = true;
    this.PoliciesModel = PoliciesModel;
    this.PoliciesStoreService = PoliciesStoreService;
    this.FlashService = FlashService;
    this.UserService = UserService;

    this.policies = { drives: {} };
    this.formData = {};
    this.formData.policymeta = {};
    this.minSessionLength = {};
    this.currentUser = UserService.getCurrentUser();
    this.daysBetweenDrivesOptions = [];
    this.session_reminder_buffers = [];
    this.bufferForm = {
      hours: 0,
    };
    for (let i = 0; i <= 90; i++) {
      let day = "days";
      if (i === 1) {
        day = "day";
      }
      this.daysBetweenDrivesOptions.push({
        name: i + " " + day,
        value: i + " " + day,
      });
    }

    this.scheduleBufferOptions = [];
    for (let i = 0; i <= 120; i++) {
      this.scheduleBufferOptions.push({
        n: i + " Hours",
        v: i * 60,
      });
    }

    const drivesPolicy = PoliciesStoreService.getPolicy("drives");
    if (drivesPolicy) {
      const policyMeta = {};
      Object.keys(drivesPolicy.policymeta).forEach((key) => {
        const value = drivesPolicy.policymeta[key];
        policyMeta[key] = isJson(value) ? JSON.parse(value) : value;
      });

      if (policyMeta.hasOwnProperty("minimum_session_length")) {
        if (parseInt(policyMeta.minimum_session_length, 10) < 60) {
          this.minSessionLength = {
            hours: 0,
            minutes: parseInt(policyMeta.minimum_session_length, 10),
          };
        } else {
          const timeString = toHoursAndMinutes(
            policyMeta.minimum_session_length,
          );
          const timeParts = timeString.split(":");
          this.minSessionLength.hours = parseInt(timeParts[0], 10);
          this.minSessionLength.minutes = parseInt(timeParts[1], 10);
        }
      }

      if (policyMeta.hasOwnProperty("session_reminder_buffer")) {
        this.session_reminder_buffers = policyMeta.session_reminder_buffer
          .map((buffer) => {
            buffer.hours = parseInt(buffer.hours, 10);
            return buffer;
          })
          .sort((a, b) => {
            return a.hours - b.hours;
          });
      }

      if (policyMeta.hasOwnProperty("use_driving_distance")) {
        policyMeta.use_driving_distance = policyMeta.use_driving_distance == 1;
      }

      if (!policyMeta.session_reminder_text) {
        policyMeta.session_reminder_text = "";
      }
      if (!policyMeta.instructor_pairing_default) {
        policyMeta.instructor_pairing_default = "Y";
      }

      if (!policyMeta.require_permit_images) {
        policyMeta.require_permit_images = "N";
      }

      if (!policyMeta.require_lesson_signatures_before_booking) {
        policyMeta.require_lesson_signatures_before_booking = "N";
      }

      policyMeta.id = drivesPolicy.id;
      this.policies.drives = { id: drivesPolicy.id, policymeta: policyMeta };
    }
    this.busy = false;
  }

  addReminderBuffer() {
    const buffer = {
      hours: this.bufferForm.hours,
    };
    this.session_reminder_buffers.push(buffer);
    this.session_reminder_buffers = this.session_reminder_buffers
      .map((buffer) => {
        buffer.hours = parseInt(buffer.hours, 10);
        return buffer;
      })
      .sort((a, b) => {
        return a.hours - b.hours;
      });
    this.bufferForm.hours = 0;
  }

  removeReminder(index) {
    this.session_reminder_buffers.splice(index, 1);
    this.session_reminder_buffers = this.session_reminder_buffers
      .map((buffer) => {
        buffer.hours = parseInt(buffer.hours, 10);
        return buffer;
      })
      .sort((a, b) => {
        return a.hours - b.hours;
      });
  }

  processPolicy(isValid) {
    if (isValid) {
      this.busy = true;
      const policy_meta = structuredClone(this.policies.drives.policymeta);
      policy_meta.minimum_session_length =
        parseInt(this.minSessionLength.hours, 10) * 60 +
        parseInt(this.minSessionLength.minutes, 10);
      policy_meta.session_reminder_buffer = this.session_reminder_buffers
        .map((buffer) => {
          buffer.hours = parseInt(buffer.hours, 10);
          return buffer;
        })
        .sort((a, b) => {
          return a.hours - b.hours;
        });
      this.PoliciesModel.update(policy_meta)
        .then((response) => {
          this.FlashService.setMessage({
            type: "success",
            message: response.message,
          });
          this.PoliciesStoreService.writePolicy("drives", policy_meta);
          this.busy = false;
        })
        .catch((error) => {
          this.busy = false;
        });
    } else {
      this.FlashService.setMessage({
        type: "error",
        message: "All fields are required.",
      });
    }
  }
}
AdminSettingsPoliciesDrivesController.$inject = [
  "PoliciesModel",
  "PoliciesStoreService",
  "FlashService",
  "UserService",
];
export default AdminSettingsPoliciesDrivesController;
